{
  "replaceMessage": "Bestand neerzetten om te vervangen"
}
